import { UIComponentViewImpl } from '../uicomponentview';
import { UIDataModel } from '../uicomponent';
import { FloatingTextComponentHandler, FloatingTextComponentProps, FloatingTextComponentState } from './floatingtextcomponent';
import { FloatingTextCSSStyle } from './floatingtextcss';
import './floatingtextcss.css';
import * as React from 'react';

export class FloatingTextViewImpl extends UIComponentViewImpl<UIDataModel>
{
    bindHandlers()
    {
        this.onChange = this.onChange.bind(this);
       
    }

    draw(props: FloatingTextComponentProps, state: FloatingTextComponentState, cssStyle: FloatingTextCSSStyle): JSX.Element | boolean
    {    
         return (
                <div style={cssStyle.getWrapperCSSStyle()}>
                    <h1 className={state.class}>{props.placeholder}</h1>
                      
                        <input value={state.value} type={props.inputType} onChange={this.onChange} onKeyDown={props.inputType === "number"? this.onKeyPress : ()=>""} style={state.errorMessage !== undefined ? cssStyle.getErrorCSSStyle() : cssStyle.getTextCSSStyle(state.class === "" ? false : true)} placeholder={props.placeholder}/>

                    {
                        state.errorMessage !== undefined && <div style={cssStyle.getErrorTextDivCSSStyle()}>
                        <label style={cssStyle.getErrorTextCSSStyle(this.getContext().getUserContext().getLanguage())}>{state.errorMessage}</label> </div>}
                </div>
       );
    }


 
  
    onChange(event: any)
    {
        (this.getUIComponentHandler() as FloatingTextComponentHandler).onChange(event.target.value);
    }
     onKeyPress(event:any)
    {
        if(event.keyCode === 69 || event.keyCode === 187 || event.keyCode === 190 || 
            event.keyCode === 189 || (event.ctrlKey && event.keyCode === 90) ||
            (event.ctrlKey && event.keyCode === 67) || (event.ctrlKey && event.keyCode === 86) ||
            (event.ctrlKey && event.keyCode === 88))
        {
            event.preventDefault();
        }
    }

}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/floatingtext/floatingtextview.tsx